class DiffContactsModalController {
    constructor($http, contact1Id, contact2Id, $q, $uibModalInstance) {
        this.api = $http;
        this.contact1Id = contact1Id;
        this.contact2Id = contact2Id;
        this.$q = $q;
        this.modalInstance = $uibModalInstance;

        this.contact1 = null;
        this.contact1 = null;
        this.loading = true;

        this.error = false;
        this.errorMessage = '';

        if (!this.contact1Id || !this.contact2Id) {
            this.error = true;
            this.errorMessage = 'Contacts have not been defined correctly';
            this.loading = false;
            return;
        }

        this.diffColumns = {
            customer_number: 'Customer Number',
            full_name: 'Full Name',
            company_name: 'Company',
            business_preferred: 'Business Preferred',
            preferred_email: 'E-Mail',
            preferred_street: 'Street',
            preferred_zip: 'Zip',
            preferred_city: 'City',
            preferred_country: 'Country',
        };

        this._updateContacts();
    }

    _updateContacts() {
        const events = [];
        this.loading = true;
        this.error = false;
        this.errorMessage = '';

        events.push(this.api.get(`contacts/${this.contact1Id}`, {'include': 'rsvps'}).then((res) => {
            this.contact1 = res.data.data;
        }));

        events.push(this.api.get(`contacts/${this.contact2Id}`, {'include': 'rsvps'}).then((res) => {
            this.contact2 = res.data.data;
        }));

        this.$q.all(events).then(() => {
            this.loading = false;
        }, () => {
            this.error = true;
            this.errorMessage = 'Error while loading contact data';
            this.loading = false;
        })
    }

    dismissModal() {
        this.modalInstance.dismiss()
    }

    doMerge(contactTo, contactFrom) {
        this.api.post(`contacts/${contactFrom.id}/merge-relations/${contactTo.id}`).then(() => {
            this.closeModal();
        }, () => {
            this.dismissModal();
        });
    }

    closeModal() {
        this.modalInstance.close()
    }
}

DiffContactsModalController.$inject = [
    '$http',
    'contact1Id',
    'contact2Id',
    '$q',
    '$uibModalInstance'
];

angular
    .module('festzelt-os.components')
    .controller('DiffContactsModalController', DiffContactsModalController);



// WEBPACK FOOTER //
// ./src/app/components/components/contact-duplicate-notice/controllers/diff-contacts-modal-controller.js